import Emblem from "./Emblem";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative bg-black border-t border-white/10 pt-16 pb-8 px-6 md:px-16"
        >
            <div className="grid grid-cols-12 gap-8 md:gap-6 mb-16">
                <div className="col-span-12 md:col-span-5 flex flex-col gap-6">
                    <div className="flex items-center gap-4">
                        <Emblem size={52} />
                        <div>
                            <div className="font-display uppercase text-3xl leading-none">
                                PaintKing
                            </div>
                            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-white/50 mt-1">
                                Paul's SoFla Fleet
                            </div>
                        </div>
                    </div>
                    <p className="font-mono text-sm text-white/60 max-w-md">
                        A family-run painting operation crowning walls across
                        South Florida. Interiors, exteriors, cabinets,
                        drywall, wallpaper — the works.
                    </p>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-white/40 mb-4">
                        Contact
                    </div>
                    <ul className="space-y-3">
                        <li>
                            <a
                                href="tel:5616984044"
                                data-testid="footer-phone"
                                className="font-display text-2xl md:text-3xl rainbow-text hover:opacity-80 transition-opacity"
                            >
                                561·698·4044
                            </a>
                        </li>
                        <li className="font-mono text-xs text-white/60">
                            Mon – Sat · 7am → 7pm
                        </li>
                        <li className="font-mono text-xs text-white/60">
                            Estimates always free.
                        </li>
                    </ul>
                </div>

                <div className="col-span-6 md:col-span-4">
                    <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-white/40 mb-4">
                        Roll With Us
                    </div>
                    <ul className="grid grid-cols-2 gap-y-2 gap-x-4 font-mono text-xs text-white/70">
                        <li><a href="#fleet" className="hover:text-white">→ Fleet</a></li>
                        <li><a href="#services" className="hover:text-white">→ Services</a></li>
                        <li><a href="#coverage" className="hover:text-white">→ Coverage</a></li>
                        <li><a href="#praise" className="hover:text-white">→ Midge Approved</a></li>
                    </ul>
                </div>
            </div>

            {/* Big wordmark */}
            <div className="relative overflow-hidden border-t border-white/10 pt-10">
                <div
                    aria-hidden
                    className="font-display uppercase leading-[0.85] tracking-[-0.045em] text-[19vw] whitespace-nowrap"
                >
                    <span className="outline-text">PAINTKING</span>{" "}
                    <span className="rainbow-text">·</span>{" "}
                    <span className="outline-text">SO·FLA</span>
                </div>
                <div className="mt-8 flex flex-col md:flex-row justify-between gap-4 font-mono text-[10px] tracking-[0.28em] uppercase text-white/40">
                    <div>
                        © {new Date().getFullYear()} PaintKing · Built by
                        family, for South Florida.
                    </div>
                    <div>Licensed · Insured · Actually shows up on time.</div>
                </div>
            </div>
        </footer>
    );
}
